import React, { useEffect } from "react";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { protectedRoutes, publicRoutes } from "./config/routes";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./muiTheme";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import Modal from "./components/modal/MessageModal";
import MessageModal from "./components/modal/MessageModal";
import { logout } from "./store/actions/user/logout";
import { logoutUser } from "./store/reducers/onboardingSlice";
import { Cookies } from "react-cookie";
import Loader from "./components/SharedLayouts/Loader";
import SessionTimeOut from "./components/modal/SessionTimeOut";

function App() {
  const { user, pendingToken } = useSelector((state) => state.onboarding);

  const cookies = new Cookies();
  const isAccessTokenAvailable = cookies.get("accessToken");

  const isModalOpened = useSelector((state) => state?.message?.isModalOpened);
  const dispatch = useDispatch();

  const modalText = useSelector((state) => state?.message?.modalText);
  const success = useSelector((state) => state?.message?.success);

  return (
    <ThemeProvider theme={theme}>
      <RouterProvider
        router={
          isAccessTokenAvailable && user?.user_id
            ? protectedRoutes
            : publicRoutes
        }
      />
      {isAccessTokenAvailable && user?.id ? (
        <>
          <SessionTimeOut />

          {pendingToken ? (
            <div className="w-full absolute top-0 left-0 z-50 bg-[rgba(0,0,0,0.6)] h-full justify-center items-center flex">
              <Loader size={"small"} />
            </div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
      {isModalOpened && <MessageModal />}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        closeOnClick
        ltr={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        hideProgressBar={true}
      />
    </ThemeProvider>
  );
}

export default App;
